import { useAuth } from "@/hooks/useAuth";
import { AppShell } from "@/components/layout/AppShell";
import { PublicNavbar } from "@/components/layout/PublicNavbar";
import { PublicFooter } from "@/components/layout/PublicFooter";
import { Outlet } from "react-router-dom";
import { useVolunteerCampaignHandoff } from "@/hooks/useVolunteerCampaignHandoff";

/**
 * Renders AppShell (sidebar, topbar) for authenticated users,
 * PublicLayout (navbar, footer) for anonymous visitors.
 *
 * Used for routes that are accessible to both (e.g. /bounty/:id, /bounties).
 */
export function AdaptiveLayout() {
  const { isAuthenticated } = useAuth();
  // Public pages sit outside AuthGuard: a poster volunteer who logs in here
  // must still reach the volunteer onboarding.
  useVolunteerCampaignHandoff();

  if (isAuthenticated) {
    return <AppShell />;
  }

  return (
    <div className="min-h-screen bg-surface">
      <PublicNavbar />
      <Outlet />
      <PublicFooter />
    </div>
  );
}
